import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=46385c54&scoped=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"
import style0 from "./Message.vue?vue&type=style&index=0&id=46385c54&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46385c54",
  null
  
)

export default component.exports